import React from 'react'
import { sendImpression, sendView } from '../services/geneLinkService'

export default class GeneLinkBanner extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      impressionSent: false,
      viewSending: false
    };
    this.handleClick = this.handleClick.bind(this);
  }

  componentDidMount() {
    if (this.state.impressionSent) {
      return;
    }
    if (!this.props.kit) {
      return;
    }
    sendImpression({
      creative_id: this.props.creative_id,
      placement: 'default-tag',
      code: this.props.kit
    });
    this.setState({ impressionSent: true });
  }

  componentDidUpdate(prevProps) {
    if (this.state.impressionSent) {
      return;
    }
    if (!prevProps.kit && this.props.kit) {
      sendImpression({
        creative_id: this.props.creative_id,
        placement: 'default-tag',
        code: this.props.kit
      });
      this.setState({ impressionSent: true });
    }
  }

  handleClick() {
    if (!this.state.viewSending) {
      this.setState({ viewSending: true });
      sendView({
        creative_id: this.props.creative_id,
        placement: 'default-tag',
        code: this.props.kit,
        sub: this.props.customer_id
      });
    }
    window.open(this.props.adscreenUrl, '_blank');
  }

  render() {
    if (!this.props.creative_id) {
      return null;
    }
    return (
      <div onClick={this.handleClick} style={{ cursor: 'pointer' }}>
        <img src={this.props.image} alt="" style={{ width: '100%', display: 'block' }} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/GeneLinkBanner.js